import { render } from "./ProfilePage.vue?vue&type=template&id=05755463&ts=true"
import script from "./ProfilePage.ts?vue&type=script&lang=ts"
export * from "./ProfilePage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__